import type { UseQueryOptions } from '@tanstack/react-query'

import { type SecureScoreTenant } from '~/types/security'

import api from '~/constants/api'

import useAccount from '~/hooks/utils/useAccount'
import useQuery from '~/hooks/utils/useQuery'

const secureScoreKeys = {
  all: ['secureScores'] as const,
  byTenant: (accountId: string, tenantId: string) => [...secureScoreKeys.all, accountId, tenantId] as const
}

export const fetchSecureScores = async (accountId: string, tenantId: string, signal?: AbortSignal): Promise<SecureScoreTenant> => {
  if (!accountId || !tenantId) throw new Error('Account ID or Tenant ID is missing')

  const response = await api.get(`/soteria/account/${accountId}/tenant/${tenantId}`, { signal })
  return response.data
}

const useSecureScoresQuery = (tenantId: string, options?: UseQueryOptions<SecureScoreTenant>) => {
  const account = useAccount()

  return useQuery(secureScoreKeys.byTenant(account.id, tenantId), ({ signal }) => fetchSecureScores(account.id, tenantId, signal), {
    enabled: !!account.id && !!tenantId && tenantId !== 'undefined',
    refetchOnWindowFocus: false,
    ...options
  })
}

export default useSecureScoresQuery
